<template>

    <div>
        <settingsNav></settingsNav>
        <v-layout row>

            <v-flex xs12 sm8 offset-sm2 mt-5>

                <!--            <v-layout row v-if="getNetworkError">
                                <v-flex xs12>
                                    <app-alert @dismissed="onDismissedError" :text="getNetworkError.message"></app-alert>
                                </v-flex>
                            </v-layout>-->

                <v-card class="white lighten-4">

                    <v-progress-linear :active="loading" :indeterminate="true"></v-progress-linear>


                    <v-container fluid class="form-content">

                        <v-card-title class="headline">
                            Account
                        </v-card-title>

                        <v-layout row wrap>

                            <v-flex xs10 md2 ma-2 pl-4>
                                <v-avatar
                                        :tile="false"
                                        :size="100"
                                        color="grey lighten-4"
                                >
                                    <img :src="ci.brand_configurations_ci.main_logo" alt="avatar">
                                </v-avatar>
                            </v-flex>

                            <v-flex xs10 md2 ma-2 ml-4>
                                <v-select
                                        :items=salutions
                                        label="Salution"
                                        v-model="account.salution"
                                        required
                                ></v-select>

                            </v-flex>

                            <v-flex xs10 md3 ma-2 ml-4>
                                <v-text-field
                                        v-model="account.firstname"
                                        label="Firstname"
                                        required
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs10 md3 ma-2 ml-4>
                                <v-text-field
                                        v-model="account.lastname"
                                        label="Lastname"
                                        required
                                ></v-text-field>
                            </v-flex>


                        </v-layout>


                        <v-layout row wrap>

                            <v-flex xs10 md2 ml-3>

                            </v-flex>
                            <v-flex xs10 md5 ma-2 ml-4>
                                <v-text-field
                                        v-model="account.email"
                                        label="E-Mail"
                                        data-vv-name="email"
                                        required
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs10 md3 ma-2 ml-4>
                                <v-text-field
                                        v-model="user.email"
                                        label="Username/Login"
                                        required
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 md4 pl-4 pr-5>
                                <v-text-field
                                        v-model="account.tel"
                                        label="Tel"
                                        data-vv-name="tel"
                                        required
                                ></v-text-field>
                            </v-flex>

                        </v-layout>

                        <v-card-title>Address:</v-card-title>

                        <v-layout row wrap>

                            <v-flex xs6 md4 ml-4 ma-2>
                                <v-text-field
                                        v-model="account.street"
                                        label="Street"
                                        required
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs3 md4 ml-4 ma-2>
                                <v-text-field
                                        v-model="account.hnumber"
                                        label="House number"
                                        required
                                ></v-text-field>
                            </v-flex>


                        </v-layout>

                        <v-layout row wrap>

                            <v-flex xs10 md4 ml-4 ma-2>
                                <v-text-field
                                        v-model="account.city"
                                        label="City"
                                        required
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs10 md4 ml-4 ma-2>
                                <v-text-field
                                        v-model="account.zipcode"
                                        label="Zip-Code"
                                        required
                                ></v-text-field>
                            </v-flex>

                        </v-layout>


                        <v-layout row>

                            <v-flex xs12 md4 ml-4 ma-2>
                                <v-autocomplete
                                        :items="countries"
                                        label="Country"
                                        v-model="account.country"
                                        required
                                ></v-autocomplete>
                            </v-flex>


                            <v-flex xs12 md4 ml-4 ma-2>
                                <v-menu
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        :return-value.sync="selectDate"
                                        lazy
                                        transition="scale-transition"
                                        offset-x
                                        full-width
                                        min-width="290px"
                                >
                                    <v-text-field
                                            slot="activator"
                                            v-model="account.birthday"
                                            label="Birthday"
                                            prepend-icon="event"
                                            readonly
                                            required
                                    ></v-text-field>
                                    <v-date-picker pb-5 mb-5 v-model="account.birthday"
                                                   :landscape=false
                                    ></v-date-picker>

                                </v-menu>
                            </v-flex>

                        </v-layout>


                        <v-card-title>Signature:</v-card-title>
                        <v-flex xs12 ml-4 mr-5 mb-3 mt-2>
                            <!--              <wysiwyg v-model="account.email_signature"></wysiwyg>-->
                            <htmlEditor v-model="account.email_signature"></htmlEditor>
                        </v-flex>

                    </v-container>

                    <v-spacer class="spacer-height"></v-spacer>

                    <v-flex pt-2 pb-5 right>

                        <v-btn :disabled="fromEdited" class="secondary white--text" @click.stop="saveAccountDetails">
                            Save Account
                            <v-icon class="white--text" right>save</v-icon>
                        </v-btn>


                    </v-flex>

                </v-card>
            </v-flex>
        </v-layout>
    </div>


</template>

<script>
    // Settings Types
    import {Settings, BrandConfigurationCI} from '../../../store/namespace-helper'
    import settingsNav from '../../Shared/SettingsNav.vue'
    import htmlEditor from '../../Shared/editor/Editr.vue'
    import {stateHelperMixin} from '../../../mixins/stateHelperMixin'
    import _ from 'lodash'

    export default {
      components: {
        settingsNav,
        htmlEditor
      },
      mixins: [stateHelperMixin],
      data () {
        return {
          date: null,
          salutions: [
            'Mr.',
            'Mrs.'
          ],
          isVisible: false,
          accountUpdated: 0,
          updatedAccountData: {},
          onDismissed: false,
          countries: this.$store.getters.countries
        }
      },
      beforeDestroy () {
        this.resetStateBeforeLeaveRoute()
      },
      mounted () {
        this.loadAccount()
      },
      methods: {
        selectDate (selectedDate) {
          this.account.birthday = selectedDate
        },
        loadAccount () {
          return this.$store.dispatch(Settings.actions.loadAccount)
        },
        saveAccountDetails () {
                // console.log("save account details: " + JSON.stringify(this.updatedAccountData))
          this.$store.dispatch('settings/saveAccount', this.updatedAccountData)
          this.accountUpdated = 1
        },
        throttledLoadAccount: _.debounce(function () {
          this.loadAccount()
        }, 350)
      },
      beforeMount () {
            // no need for initial load if visibility is tracked
            // this.loadAccount()
      },
      computed: {
        account () {
          return this.$store.getters[Settings.getters.getAccount]
        },
        user () {
          return this.$store.getters[Settings.getters.getUser]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        fromEdited () {
          console.log('updated: ' + this.accountUpdated)
          return this.accountUpdated < 2
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        },
        ci () {
          return this.$store.getters[BrandConfigurationCI.getters.defaultCI]
        }
      },
      watch: {
        account: {
          handler (val) {
            console.log('account data changed: ' + JSON.stringify(val))
            this.accountUpdated++
            this.updatedAccountData = val
          },
          deep: true
        }
      }

    }
</script>

<style scoped>
    v-avatar {
        border-color: #0b2e13;
    }

    .form-content {
        height: 65vh;
        overflow: scroll;
    }

    .spacer-height {
        height: 20px;
    }

</style>


// WEBPACK FOOTER //
// src/components/Settings/Account/Account.vue